<!--  -->
<div *ngIf="loading$ | async;"  class="global-loader"><nz-spin nzTip="Loading..."></nz-spin></div>
<layout-default [options]="options"  [content]="contentTpl" [customError]="null">

  <layout-default-header-item direction="right">
    <header-notify />
  </layout-default-header-item>
  <layout-default-header-item direction="right">
    <header-user />
  </layout-default-header-item>
  
  <ng-template #contentTpl>
    <div class="inner-content">
      <router-outlet></router-outlet>
    </div>
    <nz-footer class="full-width-footer" style="text-align: center;"> BIM ©2025 </nz-footer>
  </ng-template>
 
</layout-default>
<!-- @if (showSettingDrawer) {
  <setting-drawer />
} -->